import newRelicInstance from './newRelicInstance';
import { REQUIRED_FIELDS, NEWRELIC_ERROR } from './constants';
/**
 * addPageAction
 *
 * @memberof ux-tread-new-relic
 * @description Reports a Browser PageAction event to New Relic Insights along with a name and optional attributes in a consistent manner across all Nike Web Experiences.
 * @param {string} name - Name or Category of the action (* required for New Relic).
 * @param {object} args - one or more key/value pairs to report to Insights.
 * @example <caption>Usage of `addPageAction`</caption>
 * import { addPageAction } from '@nike/ux-tread-new-relic';
 *
 * // Rest of function implementation in here
 * const eventData = {
 *   error: 'Error goes here',
 *   info: 'More information',
 *   message: 'Doh! This is the reason for your error',
 * };
 *
 * addPageAction('jsErrorData', eventData);
 */

var addPageAction = function addPageAction(name, args) {
  try {
    // name is a required field for this New Relic function, if we don't have it,
    // then don't even attempt to hit the New Relic library.
    if (!name) throw new Error(REQUIRED_FIELDS);
    return newRelicInstance().addPageAction(name, args);
  } catch (err) {
    return console.error("".concat(NEWRELIC_ERROR, " ").concat(err)); // eslint-disable-line
  }
};

export default addPageAction;
//# sourceMappingURL=addPageAction.js.map